<template>
  <div>
    <vue-html2pdf
      :manual-pagination="true"
      pdf-content-width="100%"
      ref="html2Pdf"
      :preview-modal="false"
      :pdf-quality="2"
      :enable-download="true"
      :htmlToPdfOptions="htmlToPdfOptions"
      @hasDownloaded="$emit('closeReporte')"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <div class="row">
            <div class="col">
              <h5 style="margin-left:15px;margin-top:10px;font-size: 11px">
                Fecha: {{ getDate(ruta.datePickup) }} | {{ getTime(ruta.datePickup) }} - Pagina N° 1
              </h5>
            </div>
          </div>
          <hr class="mt-1 mb-3" />
          <div class="row">
            <div style="width:20%">
              <h3 style="margin-left:30px;font-size: 11px" class="pt-1 mb-0">
                HOJA DE RUTA N°
              </h3>
              <h3 style="margin-left:30px;font-size: 30px" class="mb-2">
                {{ ruta.numTrip }}
              </h3>
            </div>
            <table style="width:80%;font-size: 11px">
              <tr>
                <th style="padding-left:30px">Cliente: {{ getClientName(ruta.client) }}</th>
                <th>Id externo: {{ ruta.externalCode || '-' }}</th>
                <th>Contenedor: {{ ruta.numContainer || '-' }}</th>
              </tr>
              <tr>
                <th style="padding-left:30px">Recoleccion: {{ getAddress(ruta.originPort) }}</th>
                <th>Desconsolidacion: {{ getWarehouse(ruta.warehouse) }}</th>
                <th>Devolucion: {{ getAddress(ruta.destinationPort) }}</th>
              </tr>
              <tr>
                <th style="padding-left:30px">Fecha recoleccion: {{ getDate(ruta.datePickup) }} {{ getTime(ruta.datePickup) }}</th>
                <th>Fecha devolucion: {{ getDate(ruta.dateDelivery) }} {{ getTime(ruta.dateDelivery) }}</th>
                <th>Modulos: {{ ruta.quantityModules || 0 }}</th>
              </tr>
              <tr>
                <th style="padding-left:30px">Chofer recoleccion: {{ getDriver(ruta.driverPickup) }}</th>
                <th>Vehiculo recoleccion: {{ getVehicle(ruta.vehiclePickup) }}</th>
                <th>Costo total: {{ getCurrency(ruta.totalCost) }}</th>
              </tr>
              <tr>
                <th style="padding-left:30px">Chofer devolucion: {{ getDriver(ruta.driverDelivery) }}</th>
                <th>Vehiculo devolucion: {{ getVehicle(ruta.vehicleDelivery) }}</th>
                <th>Estado tareas: {{ getClosedStages(ruta.stages) }} / {{ getTotalStages(ruta.stages) }}</th>
              </tr>
            </table>
          </div>

          <hr class="mt-3 mb-2" />

          <table class="headerReportes" style="width:100%;font-size: 10px">
            <tr>
              <th class="text-center" style="width:8%">Orden</th>
              <th style="width:44%;font-size: 11px">Tarea</th>
              <th style="width:18%;font-size: 11px">Estado</th>
              <th style="width:30%;font-size: 11px">Fecha finalizacion</th>
            </tr>
          </table>
        </section>

        <section class="pdf-item" v-for="(arrStages, index) in stages" :key="index">
          <table style="width:100%;font-size: 10px" class="tablaReportes">
            <tr class="tr" v-for="stage in arrStages" :key="stage.id">
              <td class="text-center" style="width:8%;font-size: 11px">{{ stage.order }}</td>
              <td style="width:44%;font-size: 11px">{{ stage.description }}</td>
              <td style="width:18%;font-size: 11px">{{ stage.delivery ? 'Finalizada' : 'En espera' }}</td>
              <td style="width:30%;font-size: 11px">{{ toDateString(stage.delivery) || '-' }}</td>
            </tr>
          </table>

          <div class="html2pdf__page-break" v-if="!(index == stages.length - 1)" />

          <div v-if="!(index == stages.length - 1)">
            <div class="row">
              <div class="col">
                <h3 style="margin-top:10px;margin-left:30px;font-size: 12px">Hoja de ruta N° {{ ruta.numTrip }}</h3>
              </div>
              <div class="col">
                <h5 style="margin-top:10px;font-size: 11px">Fecha: {{ getDate(ruta.datePickup) }}</h5>
              </div>
              <div class="col">
                <h5 style="margin-top:10px;font-size: 11px">Pagina N° {{ index + 2 }}</h5>
              </div>
            </div>
            <hr class="mt-1 mb-2" />
          </div>
        </section>

        <section class="pdf-item">
          <div class="footer" style="padding-left:15px ; padding-right: 15px;">
            <div class="row pl-2 pr-2">
              <div class="col-md-12 footer-text mt-2 mb-2">
                <p style="font-size: 11px" class="mb-1">Observaciones:</p>
                <p style="font-size: 11px" class="mb-1">{{ ruta.observation1 || '-' }}</p>
                <p style="font-size: 11px" class="mb-1">{{ ruta.observation2 || '-' }}</p>
              </div>
            </div>

            <div class="row pl-2 pr-2">
              <div class="col-md-12 pt-0 pb-0" v-if="adicionales.length > 0">
                <table style="font-size:11px;width:100%">
                  <tr v-for="aditional in adicionales" :key="aditional.id || aditional.tipo">
                    <td style="width:50%"><p class="mb-1">{{ $t(aditional.tipo) }}:</p></td>
                    <td style="width:50%"><p class="mb-1">{{ aditional.quantity }}</p></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </section>

        <div class="html2pdf__page-break" />
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: { VueHtml2pdf },
  props: {
    ruta: Object,
    reportGenerate: Boolean,
  },
  data() {
    return {
      stages: [],
      adicionales: [],
      htmlToPdfOptions: {
        margin: [10, 0, 0, 0],
        filename: "",
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          scale: 4,
          scrollY: 0,
          scrollX: 0,
        },
        jsPDF: {
          orientation: "landscape",
          format: "a4",
        },
      },
    };
  },
  watch: {
    reportGenerate() {
      if (!this.reportGenerate || !this.ruta) {
        return;
      }

      this.adicionales = this.ruta.aditionals || [];
      this.stages = this.sliceIntoChunks(this.ruta.stages || [], 16);
      this.htmlToPdfOptions.filename = "Ruta Contenedor Nro " + this.ruta.numTrip;
      this.generateReport();
    },
  },
  methods: {
    generateReport() {
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf();
      }, 1000);
    },
    getClientName(client) {
      return client && client.nameClient ? client.nameClient : "-";
    },
    getAddress(port) {
      return port && port.dirOrigen ? port.dirOrigen : "-";
    },
    getWarehouse(warehouse) {
      return warehouse && warehouse.nameWarehouse ? warehouse.nameWarehouse : "-";
    },
    getDriver(driver) {
      return driver && driver.nameDriver ? driver.nameDriver : "-";
    },
    getVehicle(vehicle) {
      return vehicle && vehicle.patent ? vehicle.patent : "-";
    },
    getDate(value) {
      if (!value) {
        return "-";
      }

      return new Date(value).toLocaleDateString();
    },
    getTime(value) {
      if (!value || value.length < 19) {
        return "-";
      }

      return value.substr(11, 8);
    },
    getCurrency(value) {
      if (!value && value !== 0) {
        return "-";
      }

      return "$" + new Intl.NumberFormat("es-EN").format(value);
    },
    getClosedStages(stages) {
      if (!stages || stages.length === 0) {
        return 0;
      }

      let count = 0;
      stages.forEach((stage) => {
        if (stage.delivery != null) {
          count += 1;
        }
      });
      return count;
    },
    getTotalStages(stages) {
      if (!stages || stages.length === 0) {
        return 0;
      }

      return stages.length;
    },
    toDateString(dateIsoString) {
      if (!dateIsoString) {
        return null;
      }

      const dateSplit = dateIsoString.split("T");
      const hourSplit = dateSplit[1].split("-");
      const daySplit = dateSplit[0].split("-");
      return daySplit[2] + "-" + daySplit[1] + "-" + daySplit[0] + " " + hourSplit[0];
    },
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
  },
};
</script>
